
import secureLocalStorage from "react-secure-storage"
import { toast } from "react-toastify"
import { ErrorService } from "../Services/errorService"
import i18n from "../Translations/i18n"

const handleError = (error: any) => {
    const status = error?.response?.status?.toString() ?? ""
    console.error("handleError", {
        status: error?.response?.status,
        internalCode: error?.response?.data?.internalCode,
        message: error?.response?.data?.message ?? error?.message,
        data: error?.response?.data,
        error,
    });

    if (status.startsWith("5")) {
        secureLocalStorage.setItem("error", error)
        new ErrorService().fetchStackTrace().then((response) => {
            secureLocalStorage.setItem("stackTrace", response.data)
        }).then(() => {
            window.location.href = `#/error-handling`;
        })
        return
    }

    if (error?.response) {
        const apiResponse = error.response.data
        const message = apiResponse?.message
        if (message) {
            toast.error(i18n.t(message), { autoClose: 2000 })
        } else {
            toast.error(i18n.t("common.failed"), { autoClose: 1500 })
        }
    }
}


export default handleError
